var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"spinner-right spinner-white",class:{
    spinner: _vm.loading,
  },attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.load()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }